module.exports = "\r\n<div id=\"pdf-canvas\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/views/IntelligentGeneration/pdf.html
// module id = 378
// module chunks = 1